import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button } from 'react-bootstrap';
import ColumnFormatter from '../../common/ColumnFormatter';

export class Cases extends Component {
    displayName = Cases.name


    constructor(props) {
        super(props);
        this.state = { data: [], loading: true };

        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Content-Type': 'application/json'
            }
        };

        fetch(`api/PollService/${localStorage.getItem('agency_key')}/cases`, requestOptions)
            .then(response => response.json())
            .then(data => this.setState({ data, loading: false }));
    }

    checkAllCases() {

        let url = `api/PollService/${localStorage.getItem('agency_key')}/case/checkall`;

        const requestOptions = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${this.props.auth.getAccessToken()}`,
                'Content-Type': 'application/json'
            }
        };

        fetch(url, requestOptions)
            .then(response => response.json());

        this.forceUpdate();
    }

    rowClassNameFormat(row, rowIdx) {
        let today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        let upateDate = new Date(row.lastStatusUpdate);
        return today < upateDate ? 'tr-highlight' : '';
    }


    renderCases(data) {
        const options = {
            sortName: 'lastStatusUpdate',
            sortOrder: 'desc',
            sizePerPage: 20
        };

        return (
            <div>
                <h2>Cases
                    <div style={{ position: 'float' }}>
                        <small>
                            <a href="https://egov.uscis.gov/casestatus/landing.do" rel="noopener noreferrer"
                                target="_blank">Go to USCIS Case Check</a>
                        </small>
                    </div>
                </h2>

                <div>
                    <BootstrapTable data={data} pagination search={true} hover
                        bordered={true} trClassName={this.rowClassNameFormat}
                        options={options}>

                        <TableHeaderColumn dataField='clientId' dataSort
                            width='5%' dataFormat={ColumnFormatter.editClientFormatter}>Id</TableHeaderColumn>

                        <TableHeaderColumn dataField='applicantCaseId' isKey dataSort
                            width='20%'>Case Id</TableHeaderColumn>

                        <TableHeaderColumn dataField='caseType' width='6%' dataSort>Type</TableHeaderColumn>

                        <TableHeaderColumn dataField='status' dataSort width='25%'>Status</TableHeaderColumn>

                        <TableHeaderColumn dataField='lastStatusUpdate' dataFormat={ColumnFormatter.asDate} dataSort
                            width='15%'>Last USCIS Update</TableHeaderColumn>

                        <TableHeaderColumn dataField='lastCheckDate' dataFormat={ColumnFormatter.asDateTime} dataSort
                            width='19%'>Last Check Date</TableHeaderColumn>

                    </BootstrapTable>

                    <Button style={{ position: 'absolute', right: 10 }} bsStyle="danger" onClick={() => this.checkAllCases()}>Run Status Updates</Button>
                </div>
            </div>

        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderCases(this.state.data);

        return (
            <div>
                {contents}
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./src/components/Cases/Cases.js